import { type BusinessHoursInput } from '@fullcalendar/core';
import { Frequency as RRuleFrequency, RRule } from 'rrule';

import { MonitoringHoursType } from '../../models/index.js';
import { UpdateType } from '../../types/index.js';

export type Day = {
  label: string;
  value: number;
};

export const DAYS: Day[] = [
  { label: 'Monday', value: RRule.MO.weekday },
  { label: 'Tuesday', value: RRule.TU.weekday },
  { label: 'Wednesday', value: RRule.WE.weekday },
  { label: 'Thursday', value: RRule.TH.weekday },
  { label: 'Friday', value: RRule.FR.weekday },
  { label: 'Saturday', value: RRule.SA.weekday },
  { label: 'Sunday', value: RRule.SU.weekday },
];

export type Frequency = {
  label: string;
  value: RRuleFrequency;
};

export const FREQUENCIES: Frequency[] = [
  {
    label: 'Daily',
    value: RRuleFrequency.DAILY,
  },
  {
    label: 'Weekly',
    value: RRuleFrequency.WEEKLY,
  },
];

export type RuleType = {
  label: string;
  value: MonitoringHoursType;
};

export const RULE_TYPES: RuleType[] = [
  {
    label: 'Full Monitoring',
    value: MonitoringHoursType.MONITORING,
  },
  {
    label: 'Check-in',
    value: MonitoringHoursType.CHECK_IN,
  },
];

export const UPDATE_TYPES = [
  {
    label: 'Current Event',
    value: UpdateType.EVENT,
  },
  {
    label: 'Current Event and all future events',
    value: UpdateType.RULE,
  },
];
export const CheckInDurations = [10, 15, 20, 25, 30];
export const MIN_CHECK_IN_INTERVAL_HOURS = 1;
export const MAX_CHECK_IN_INTERVAL_HOURS = 12;
export const CheckInIntervals = Array.from(
  { length: MAX_CHECK_IN_INTERVAL_HOURS - MIN_CHECK_IN_INTERVAL_HOURS + 1 },
  (_value, index) => MIN_CHECK_IN_INTERVAL_HOURS + index,
);
export const NUMBER_OF_DAYS_BEHIND = -31;
export const businessHours: BusinessHoursInput = [
  {
    startTime: '07:00',
    endTime: '19:00',
    daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    startTime: '19:00',
    endTime: '07:00',
    daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
  },
];
